const DATA_ONLY_DEFAULT_PATH = '/insights'

const canAccessConversationViews = (user) => {
  if (user?.isDemoUser) return false

  // Read-only is a view mode inside TextConversations. The route guard should
  // only enforce who can reach conversation views at all.
  if (user?.isDataOnlyUser) return Boolean(user?.isInternal || user?.isAdmin)

  return true
}

export {
  DATA_ONLY_DEFAULT_PATH,
  canAccessConversationViews,
}
